import { createContext, useContext, type PropsWithChildren } from "react";
import { useOnline } from "shared/hooks/useOnline";

export interface OfflineContextValue {
    isOnline: boolean;
}

const OfflineContext = createContext<OfflineContextValue>({ isOnline: true });

export function OfflineProvider({ children }: PropsWithChildren) {
    const { isOnline } = useOnline();
    return <OfflineContext.Provider value={{ isOnline }}>{children}</OfflineContext.Provider>;
}

export function useOfflineContext(): OfflineContextValue {
    return useContext(OfflineContext);
}
